import "react-datetime/css/react-datetime.css";
import './styles.css';
import { beDecisionTypeCards } from './beModalData';

const classificationElements = ['Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'];
const normalBalanceElements = ['Debit', 'Credit'];

export default function InstructorAssignmentLevelSavedAccounts({ gameType, scenarioLevels, activeScenarioLevel }) {
  const isNormalBalance = gameType?.includes('Normal Balance');
  const isClassification = gameType?.includes('Classification');

  const getScenarioData = (typeKey) =>
    isClassification
      ? scenarioLevels[activeScenarioLevel]?.[typeKey]
      : isNormalBalance
        ? scenarioLevels[activeScenarioLevel]?.[`normal_${typeKey}`]
        : gameType?.includes('Balanced Equation')
          ? scenarioLevels[activeScenarioLevel]?.[`be_${typeKey}`]
          : gameType?.includes('Principles') && typeKey === 'questions'
            ? scenarioLevels[activeScenarioLevel]?.[`transactions`]
          : [];

  const options = getScenarioData('options');
  const questions = getScenarioData('questions');

  const isLevel1 = scenarioLevels[activeScenarioLevel]?.level === 1;

  let displayOptions = options;
  if (isNormalBalance) {
    // Normal Balance always groups accounts by their natural normal-
    // balance side, regardless of which option records were saved on
    // the level itself. Older levels may have inherited Balance Sheet
    // / Income Statement / element drop-zones from creation, but the
    // Normal Balance summary view should only ever show Debit and
    // Credit columns.
    displayOptions = normalBalanceElements.map(name => ({ account_item: { name } }));
  } else if (isClassification && !isLevel1) {
    displayOptions = classificationElements.map(name => ({ account_item: { name } }));
  }

  // For Normal Balance the bucket key is each question's
  // account_item.normal ('debit' / 'credit'); other games bucket by
  // the financial-statement parent (Assets / Liabilities / etc.) on
  // account_item.parents.
  const getRelatedQuestions = (option) => {
    if (isNormalBalance) {
      const target = option.account_item?.name?.toLowerCase();
      return questions.filter(q =>
        typeof q.account_item?.normal === 'string'
        && q.account_item.normal.toLowerCase() === target
      );
    }
    return questions.filter(q =>
      q.account_item.parents?.includes(option.account_item.name)
    );
  };

  // For BE, the description shown above the Transactions list is
  // pulled from the same card definitions that drive the Add Level
  // modal (beModalData.js), keyed by the level's decision type
  // (level.name = 'increase-decrease' | 'debit-credit' | etc.). When
  // the level's name doesn't match a card, no copy is rendered.
  const renderBalancedEquationCopy = () => {
    const levelName = scenarioLevels[activeScenarioLevel]?.name;
    const card = beDecisionTypeCards.find(c => c.key === levelName);
    if (!card) return null;
    return (
      <p>
        {card.description.map((seg, i) =>
          seg.bold ? <b key={i}>{seg.text}</b> : <span key={i}>{seg.text}</span>
        )}
      </p>
    );
  };

  const renderQuestions = (questions, label) => (
    <div className="instructor-level-saved-accounts-column">
      {gameType === 'Balanced Equation' && renderBalancedEquationCopy()}
      <h4>{label}</h4>
      <ul className="instructor-level-saved-accounts-list">
        {
          questions?.map((relatedQuestion, relatedQuestionIndex) => (
            <li
              key={`saved-account-question-${relatedQuestionIndex}`}
            >
              {relatedQuestion.description}
            </li>
          ))
        }
      </ul>
    </div>
  );

  if (gameType?.includes('Balanced Equation') || gameType?.includes('Principles')) {
    return (
      <div className="instructor-level-saved-accounts">
        {renderQuestions(questions, 'Transactions')}
      </div>
    );
  }

  return (
    <div className="instructor-level-saved-accounts">
      {
        displayOptions?.map((option, optionIndex) => {
          const relatedQuestions = getRelatedQuestions(option);

          return (
            <div
              key={`saved-column-${optionIndex}`}
              className="instructor-level-saved-accounts-column"
            >
              <h4>{option.account_item?.name}</h4>
              <ul className="instructor-level-saved-accounts-list">
                {
                  relatedQuestions.map((relatedQuestion, relatedQuestionIndex) => (
                    <li
                      key={`saved-account-question-${relatedQuestionIndex}`}
                    >
                      {relatedQuestion.account_item.name}
                    </li>
                  ))
                }
              </ul>
            </div>
          );
        })
      }
    </div>
  );
}
